import './main.scss';

function findOutLinks() {
  let links = document.body.querySelectorAll('.personPage__bio-content a');
  if(links.length > 0){
    for(let item of links) {
      if(item.href){
        if(item.href.indexOf('http://www.mos.ru') === 0 || 
          item.href.indexOf('http://mos.ru') === 0 || 
          item.href.indexOf('https://www.mos.ru') === 0 || 
          item.href.indexOf('https://mos.ru') === 0 )
        {
          item.setAttribute('target', '_self');
        } else {
          item.setAttribute('target', '_blank');
        }
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", findOutLinks);